import React from "react";

/** 4xx.svg */
const PATH_4XX = "/assets/4xx-21c2d179232708c319bde14a5af783635b6ad37ea1a1060afcac243f39fb8cf3.svg";

/** 5xx.svg */
const PATH_5XX = "/assets/5xx-2e1fd14b9e37f4069a434baa4cc0c4c5385b53c736fe5fa3e88794858dbbe2a4.svg";

/** avatar/avatar0.svg */
const PATH_AVATAR_AVATAR0 = "/assets/avatar/avatar0-d3abc3668547bfd21699e57122638bf2345f7e4b90a3c6803a7bc013e661e60b.svg";

/** avatar/avatar1.svg */
const PATH_AVATAR_AVATAR1 = "/assets/avatar/avatar1-34ec93f1ec1200314a120d81562d7a4ae49e90bc81b4765d87d70d9dce1d778f.svg";

/** avatar/avatar10.svg */
const PATH_AVATAR_AVATAR10 = "/assets/avatar/avatar10-6f4153a364d7fe67097e69830dc809d6a63fbe7151553d01ad27c28c7718a2b0.svg";

/** avatar/avatar11.svg */
const PATH_AVATAR_AVATAR11 = "/assets/avatar/avatar11-7bbe5b6287fb70f857a0095e26ae3423b543e674522050c62169a10caa976a07.svg";

/** avatar/avatar12.svg */
const PATH_AVATAR_AVATAR12 = "/assets/avatar/avatar12-af3c7343856cb40ff9a88ebd92518e043601e592f0330eccc8b28ee81a796b41.svg";

/** avatar/avatar13.svg */
const PATH_AVATAR_AVATAR13 = "/assets/avatar/avatar13-c28a9aa2f60614429227bfa337c7eb6a2c16f3c4784a0aa09e7cc7946723ca99.svg";

/** avatar/avatar14.svg */
const PATH_AVATAR_AVATAR14 = "/assets/avatar/avatar14-67f9c8c70306492579a816b318b64b831b6b692e7c8f64a499d5b61333d12a28.svg";

/** avatar/avatar15.svg */
const PATH_AVATAR_AVATAR15 = "/assets/avatar/avatar15-0d5040e89ccb5b94f289e0bc9e6799f82b67fa7a76dc5e3a8385b78246a40473.svg";

/** avatar/avatar16.svg */
const PATH_AVATAR_AVATAR16 = "/assets/avatar/avatar16-4da493cde9e6c6c02dab5ea2cd3c4d69a7291749105f75b3781a723381e05c00.svg";

/** avatar/avatar17.svg */
const PATH_AVATAR_AVATAR17 = "/assets/avatar/avatar17-2e967f97a20dd7c461b7daaefe19c254a6067f8af54960fb6efb628703630e31.svg";

/** avatar/avatar18.svg */
const PATH_AVATAR_AVATAR18 = "/assets/avatar/avatar18-14119622034eaa9d781cc3dff35e3857d8c8a5277ef153d894e0a2f8040a354d.svg";

/** avatar/avatar19.svg */
const PATH_AVATAR_AVATAR19 = "/assets/avatar/avatar19-8b60e02adad6792974bf6c41abee369251a06f5f98f0bfe4f806d9e065a14cb4.svg";

/** avatar/avatar2.svg */
const PATH_AVATAR_AVATAR2 = "/assets/avatar/avatar2-3903785cab1fc8678341b1d80a1381c0fd9c494f345e0c16dfd7be5337832881.svg";

/** avatar/avatar20.svg */
const PATH_AVATAR_AVATAR20 = "/assets/avatar/avatar20-e8d2a612db4a23fddc72347f30b4a2e1bd45118d07a8341cb15f128de146ea81.svg";

/** avatar/avatar21.svg */
const PATH_AVATAR_AVATAR21 = "/assets/avatar/avatar21-862dd29058d2c497d8d3c164c977a3482451305a3fc922927bf842a6b92820d1.svg";

/** avatar/avatar22.svg */
const PATH_AVATAR_AVATAR22 = "/assets/avatar/avatar22-cb25eaef1d913b904962ae7df737ca6e7df4be2fa3fe85be30ec11a8eae1ae7d.svg";

/** avatar/avatar23.svg */
const PATH_AVATAR_AVATAR23 = "/assets/avatar/avatar23-7a52f291033caa3113abd9fdceb3a2f5f38e407e5f7eac287bb76058f355e456.svg";

/** avatar/avatar24.svg */
const PATH_AVATAR_AVATAR24 = "/assets/avatar/avatar24-c99607900472abe5408fd117921ad5fd1c9b53a05b7a267423b01a5842f83d5d.svg";

/** avatar/avatar25.svg */
const PATH_AVATAR_AVATAR25 = "/assets/avatar/avatar25-c273846bf40252df21042ee8f6801b9083d3e1104d9152ace5957700c2440d6a.svg";

/** avatar/avatar26.svg */
const PATH_AVATAR_AVATAR26 = "/assets/avatar/avatar26-f79d20aef8a7367c664f840fca4c852d83a499d0860a51784d43965236c5c459.svg";

/** avatar/avatar27.svg */
const PATH_AVATAR_AVATAR27 = "/assets/avatar/avatar27-1feaec4a999cae4004468c570d139f76a1e04a2e3aa3115fc2052147e20c6a16.svg";

/** avatar/avatar28.svg */
const PATH_AVATAR_AVATAR28 = "/assets/avatar/avatar28-35bb8a0bed8661ff3c3858a86c531cc3be39a495854785e5f6ea35905b78de7e.svg";

/** avatar/avatar29.svg */
const PATH_AVATAR_AVATAR29 = "/assets/avatar/avatar29-b0917fcc2f948cb01420cf3d0f42ad07657bd5df6f4e44e052b188fcf7911a10.svg";

/** avatar/avatar3.svg */
const PATH_AVATAR_AVATAR3 = "/assets/avatar/avatar3-629f251c73f64b7100aa9b9240761b8b903ad674ea1d3f541d9438d4e5725b0f.svg";

/** avatar/avatar4.svg */
const PATH_AVATAR_AVATAR4 = "/assets/avatar/avatar4-4a83a3ebb55bffc895ff58272668ceedcc61fa8e6852bdb02d09d37c712080bf.svg";

/** avatar/avatar5.svg */
const PATH_AVATAR_AVATAR5 = "/assets/avatar/avatar5-1fdb122a3d1c07ebd9a8f0206bc44b8f7e209c137731cc5de4fc9322c674174a.svg";

/** avatar/avatar6.svg */
const PATH_AVATAR_AVATAR6 = "/assets/avatar/avatar6-7d8eb80e6fdbcda508ba5e96e8575e779c5c383cdfe0a1878917abb595300127.svg";

/** avatar/avatar7.svg */
const PATH_AVATAR_AVATAR7 = "/assets/avatar/avatar7-2154b00e8ba9698f550fdc932c927c8129acfbe29c8002333cdf85dad3e2628c.svg";

/** avatar/avatar8.svg */
const PATH_AVATAR_AVATAR8 = "/assets/avatar/avatar8-9e63dd3b7136635b38a2191fa098c9b9bf2ebb92dd8708ba288a104ce5a0a47d.svg";

/** avatar/avatar9.svg */
const PATH_AVATAR_AVATAR9 = "/assets/avatar/avatar9-ecc4feba290c4d8a8c32033adc29cdd0f91ba1534ad1f522cfbb144843754c0e.svg";

/** brand/kibelo.svg */
const PATH_BRAND_KIBELO = "/assets/brand/kibelo-b11210ecf48633e0116da563bbb00dbf408264d376d2a32ebc49452c414a15b7.svg";

/** credit_card/amex.svg */
const PATH_CREDIT_CARD_AMEX = "/assets/credit_card/amex-eaa31998980b868c1ec136efe03f03e6437ccae24b99549539a6ce3077237f11.svg";

/** credit_card/jcb.svg */
const PATH_CREDIT_CARD_JCB = "/assets/credit_card/jcb-0197440955eac88a80f9f4b52997b06710feac7c7d533e8d63aaf7bd10e957bb.svg";

/** credit_card/mastercard.svg */
const PATH_CREDIT_CARD_MASTERCARD = "/assets/credit_card/mastercard-d3d09ebf1c76e16650bad22b267bd1ed2c48440ffb16027e8d8b7f5fb441407b.svg";

/** credit_card/visa.svg */
const PATH_CREDIT_CARD_VISA = "/assets/credit_card/visa-16885a96ddca655018637e252b51c6e94f20ea15671dd7c5403b4951fbfcf26a.svg";

/** emptystate/en/blog_feed@2x.png */
const PATH_EMPTYSTATE_EN_BLOG_FEED_2X = "/assets/emptystate/en/blog_feed@2x-72417d456f605e8f9b87f1db20c7ab38696ca7286963c1a9a5801266a1447d01.png";

/** emptystate/en/wiki_feed@2x.png */
const PATH_EMPTYSTATE_EN_WIKI_FEED_2X = "/assets/emptystate/en/wiki_feed@2x-323552cce1fa32b2b2d4a91fccdb46bb73bca04675a3f0fa4576f5ddd8e95507.png";

/** emptystate/en/wiki_tree@2x.png */
const PATH_EMPTYSTATE_EN_WIKI_TREE_2X = "/assets/emptystate/en/wiki_tree@2x-e9472a9a57520fdb56f4abb600a563c51f9f130f2e02c0747384d05811fd7cd1.png";

/** emptystate/ja/blog_feed@2x.png */
const PATH_EMPTYSTATE_JA_BLOG_FEED_2X = "/assets/emptystate/ja/blog_feed@2x-07e1e2ecc81293f2592fd09b9ab7712e25fdd7f6ae2c126f7dc5512e803ddcf4.png";

/** emptystate/ja/wiki_feed@2x.png */
const PATH_EMPTYSTATE_JA_WIKI_FEED_2X = "/assets/emptystate/ja/wiki_feed@2x-e4f3cb0e12a4c3c7925674d0854ddd88df6c29442d1d57b1dc9fa548ec981044.png";

/** emptystate/ja/wiki_tree@2x.png */
const PATH_EMPTYSTATE_JA_WIKI_TREE_2X = "/assets/emptystate/ja/wiki_tree@2x-68c2cda39127920e05dcf7166bf28aa9f02835928e5d7e1357b4c7bd29afd3b6.png";

/** feed/empty_box_bg.png */
const PATH_FEED_EMPTY_BOX_BG = "/assets/feed/empty_box_bg-5108b6a63b0877168b62099096547c5008ebd86fb36cb507263230bf0798aff3.png";

/** feed/empty_box_bg@2x.png */
const PATH_FEED_EMPTY_BOX_BG_2X = "/assets/feed/empty_box_bg@2x-48eaf7e78fb05aa5132c4625d930a5c31e87fca4e65c68db4bca8a2c41404a37.png";

/** icon-192.png */
const PATH_ICON_192 = "/assets/icon-192-a094d0dda957698024f91aa10e8b9ca936dc848754a6e88262be5a1a6aaca4c4.png";

/** importer/docbase_logo.png */
const PATH_IMPORTER_DOCBASE_LOGO = "/assets/importer/docbase_logo-3651aba42ecb0232a9ed632452f5a4e19a327daaeaec49c256ceda13165845cb.png";

/** importer/docbase_logo@2x.png */
const PATH_IMPORTER_DOCBASE_LOGO_2X = "/assets/importer/docbase_logo@2x-f038ce268fb99ac2fbe2e0b12ec103486c217a4951746dd951befb74817e974d.png";

/** importer/esa_logo.jpg */
const PATH_IMPORTER_ESA_LOGO = "/assets/importer/esa_logo-1a9da322481a43b2c892a2527730488e1eecf25e97d58720244808c38953c892.jpg";

/** importer/esa_logo@2x.jpg */
const PATH_IMPORTER_ESA_LOGO_2X = "/assets/importer/esa_logo@2x-ead03442d3124dc5fabd1c641b3d70bff14c48bf1c5901aaea12d5482f7ac36a.jpg";

/** importer/qiita_team_logo.png */
const PATH_IMPORTER_QIITA_TEAM_LOGO = "/assets/importer/qiita_team_logo-b76f436d0e16c491b85c2ac83f11e276485a76dd117f02e94951063c19126b95.png";

/** importer/qiita_team_logo@2x.png */
const PATH_IMPORTER_QIITA_TEAM_LOGO_2X = "/assets/importer/qiita_team_logo@2x-8d6352a7539d490191ecf13c1e8696eb3557a1596c8b8079cbb200dadfcd5754.png";

/** kibela_logo.svg */
const PATH_KIBELA_LOGO = "/assets/kibela_logo-18bb447dfc0fe9b71ad3c05572b12e3f76e97de2ed3e04bfb2cde980c9055f5b.svg";

/** kibela_logo_staging.svg */
const PATH_KIBELA_LOGO_STAGING = "/assets/kibela_logo_staging-c66707e315b39df10482a748f7a36bcbbf8578a2a9404bfdabf33ac86efe6aeb.svg";

/** landing/icon-patterns.png */
const PATH_LANDING_ICON_PATTERNS = "/assets/landing/icon-patterns-05b1f496acb64aa1f868ff1caf774151a42d2cea2aef900fd2b8f16129057111.png";

/** landing/pattern-bg.png */
const PATH_LANDING_PATTERN_BG = "/assets/landing/pattern-bg-0b853949c57a9fc227b800b628d18e98d69d58305a4348b1ab04bf26555caebe.png";

/** landing/pmark.png */
const PATH_LANDING_PMARK = "/assets/landing/pmark-b46cacd105cb80e513dd328a10bc33617ccaac58356aa78f7a9d524def2a5b90.png";

/** on_boarding/en/1@2x.png */
const PATH_ON_BOARDING_EN_1_2X = "/assets/on_boarding/en/1@2x-80e452d1202949297d60a18b1734574055b1eab18fda21a828161712eb9e82f6.png";

/** on_boarding/en/2@2x.png */
const PATH_ON_BOARDING_EN_2_2X = "/assets/on_boarding/en/2@2x-36c1f55e09cc4bb008ee8528a5a3b4ae9ff1521546a7ea84e57daf3663d79823.png";

/** on_boarding/en/3@2x.png */
const PATH_ON_BOARDING_EN_3_2X = "/assets/on_boarding/en/3@2x-092069a70d3b8460027b1fa199dc5de1212d79a49c49586720a8bf0fa11178fc.png";

/** on_boarding/en/4@2x.png */
const PATH_ON_BOARDING_EN_4_2X = "/assets/on_boarding/en/4@2x-e1f0801075e1263d283bbb79ef026c689c9690afa33ba761bac97a69e08afff2.png";

/** on_boarding/ja/1@2x.png */
const PATH_ON_BOARDING_JA_1_2X = "/assets/on_boarding/ja/1@2x-1834b1815e87b79fe98719e7f7d45c2de14dbe7b70ea569aadc31c033d2b51b1.png";

/** on_boarding/ja/2@2x.png */
const PATH_ON_BOARDING_JA_2_2X = "/assets/on_boarding/ja/2@2x-8a105132c978acd812d33b14eb71d65b8fb0cb53523f567f6095ef68dc5b57cf.png";

/** on_boarding/ja/3@2x.png */
const PATH_ON_BOARDING_JA_3_2X = "/assets/on_boarding/ja/3@2x-285eee55a6ee27520056901f902066b5573d689fa18e0eb63c219d37c251375c.png";

/** on_boarding/ja/4@2x.png */
const PATH_ON_BOARDING_JA_4_2X = "/assets/on_boarding/ja/4@2x-fe54da3004e1e3f6bab3f40bc635da8c671038bb1577bcceec3993911cdafb72.png";

/** shortcut_icon.png */
const PATH_SHORTCUT_ICON = "/assets/shortcut_icon-99b5d6891a0a53624ab74ef26a28079e37c4f953af6ea62396f060d3916df061.png";

/** sorry.png */
const PATH_SORRY = "/assets/sorry-60fc5d6b93188a6f8b187e6afe6489c1c31bb581e4d383428a6609c267f5c486.png";

/** square_seal.png */
const PATH_SQUARE_SEAL = "/assets/square_seal-703b5e021b975e54ba4056483455e318da29fd311344d8933480352fc6dbf4d3.png";

/** terms/pmark-en.gif */
const PATH_TERMS_PMARK_EN = "/assets/terms/pmark-en-73e8c87dcb19099de270ea7a28e06bb35619274220ac6a5e9aa8a4782b8b42d6.gif";

/** terms/pmark-ja.gif */
const PATH_TERMS_PMARK_JA = "/assets/terms/pmark-ja-3bce54d8cd90dee8cf6efc4c7ccf60762705d7c294e709e6a5ba56807cf6fbdc.gif";

/** toast/error.svg */
const PATH_TOAST_ERROR = "/assets/toast/error-36f5e80a817bd3526f831e4c1a637fbd0150ff128d01c6266356f906e0021686.svg";

/** toast/success.svg */
const PATH_TOAST_SUCCESS = "/assets/toast/success-113d8c6567441218600adb7fd8a9cf2de8c877aa61df3c5cef9503e5b6d22e16.svg";

/** webhook/microsoft_teams_icon.svg */
const PATH_WEBHOOK_MICROSOFT_TEAMS_ICON = "/assets/webhook/microsoft_teams_icon-15eaad4fa2438ed74df2f5d6d75e91ec19fc83a1f7ba98a49a3c23d99c6f1151.svg";

/** webhook/slack_icon@1x.png */
const PATH_WEBHOOK_SLACK_ICON_1X = "/assets/webhook/slack_icon@1x-b20e4fc3b21fec817f2e5733970a38183188aadc0b8e0fb1a25c583b6bf61bf5.png";

/** webhook/slack_icon@2x.png */
const PATH_WEBHOOK_SLACK_ICON_2X = "/assets/webhook/slack_icon@2x-461bc4bbcd74d696c327c3582aa8303569e26548e99278dec28ebb3d134b44f1.png";

/** 4xx */
export function Image4xx(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="4xx"
                width={208}
                height={154}
                src={PATH_4XX}
                srcSet={`${PATH_4XX} 1x`}
                {...props}
                />;
}

/** 5xx */
export function Image5xx(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="5xx"
                width={143}
                height={137}
                src={PATH_5XX}
                srcSet={`${PATH_5XX} 1x`}
                {...props}
                />;
}

/** avatar/avatar0 */
export function ImageAvatarAvatar0(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="avatar0"
                width={32}
                height={32}
                src={PATH_AVATAR_AVATAR0}
                srcSet={`${PATH_AVATAR_AVATAR0} 1x`}
                {...props}
                />;
}

/** avatar/avatar1 */
export function ImageAvatarAvatar1(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="avatar1"
                width={32}
                height={32}
                src={PATH_AVATAR_AVATAR1}
                srcSet={`${PATH_AVATAR_AVATAR1} 1x`}
                {...props}
                />;
}

/** avatar/avatar10 */
export function ImageAvatarAvatar10(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="avatar10"
                width={32}
                height={32}
                src={PATH_AVATAR_AVATAR10}
                srcSet={`${PATH_AVATAR_AVATAR10} 1x`}
                {...props}
                />;
}

/** avatar/avatar11 */
export function ImageAvatarAvatar11(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="avatar11"
                width={32}
                height={32}
                src={PATH_AVATAR_AVATAR11}
                srcSet={`${PATH_AVATAR_AVATAR11} 1x`}
                {...props}
                />;
}

/** avatar/avatar12 */
export function ImageAvatarAvatar12(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="avatar12"
                width={32}
                height={32}
                src={PATH_AVATAR_AVATAR12}
                srcSet={`${PATH_AVATAR_AVATAR12} 1x`}
                {...props}
                />;
}

/** avatar/avatar13 */
export function ImageAvatarAvatar13(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="avatar13"
                width={32}
                height={32}
                src={PATH_AVATAR_AVATAR13}
                srcSet={`${PATH_AVATAR_AVATAR13} 1x`}
                {...props}
                />;
}

/** avatar/avatar14 */
export function ImageAvatarAvatar14(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="avatar14"
                width={32}
                height={32}
                src={PATH_AVATAR_AVATAR14}
                srcSet={`${PATH_AVATAR_AVATAR14} 1x`}
                {...props}
                />;
}

/** avatar/avatar15 */
export function ImageAvatarAvatar15(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="avatar15"
                width={32}
                height={32}
                src={PATH_AVATAR_AVATAR15}
                srcSet={`${PATH_AVATAR_AVATAR15} 1x`}
                {...props}
                />;
}

/** avatar/avatar16 */
export function ImageAvatarAvatar16(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="avatar16"
                width={32}
                height={32}
                src={PATH_AVATAR_AVATAR16}
                srcSet={`${PATH_AVATAR_AVATAR16} 1x`}
                {...props}
                />;
}

/** avatar/avatar17 */
export function ImageAvatarAvatar17(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="avatar17"
                width={32}
                height={32}
                src={PATH_AVATAR_AVATAR17}
                srcSet={`${PATH_AVATAR_AVATAR17} 1x`}
                {...props}
                />;
}

/** avatar/avatar18 */
export function ImageAvatarAvatar18(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="avatar18"
                width={32}
                height={32}
                src={PATH_AVATAR_AVATAR18}
                srcSet={`${PATH_AVATAR_AVATAR18} 1x`}
                {...props}
                />;
}

/** avatar/avatar19 */
export function ImageAvatarAvatar19(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="avatar19"
                width={32}
                height={32}
                src={PATH_AVATAR_AVATAR19}
                srcSet={`${PATH_AVATAR_AVATAR19} 1x`}
                {...props}
                />;
}

/** avatar/avatar2 */
export function ImageAvatarAvatar2(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="avatar2"
                width={32}
                height={32}
                src={PATH_AVATAR_AVATAR2}
                srcSet={`${PATH_AVATAR_AVATAR2} 1x`}
                {...props}
                />;
}

/** avatar/avatar20 */
export function ImageAvatarAvatar20(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="avatar20"
                width={32}
                height={32}
                src={PATH_AVATAR_AVATAR20}
                srcSet={`${PATH_AVATAR_AVATAR20} 1x`}
                {...props}
                />;
}

/** avatar/avatar21 */
export function ImageAvatarAvatar21(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="avatar21"
                width={32}
                height={32}
                src={PATH_AVATAR_AVATAR21}
                srcSet={`${PATH_AVATAR_AVATAR21} 1x`}
                {...props}
                />;
}

/** avatar/avatar22 */
export function ImageAvatarAvatar22(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="avatar22"
                width={32}
                height={32}
                src={PATH_AVATAR_AVATAR22}
                srcSet={`${PATH_AVATAR_AVATAR22} 1x`}
                {...props}
                />;
}

/** avatar/avatar23 */
export function ImageAvatarAvatar23(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="avatar23"
                width={32}
                height={32}
                src={PATH_AVATAR_AVATAR23}
                srcSet={`${PATH_AVATAR_AVATAR23} 1x`}
                {...props}
                />;
}

/** avatar/avatar24 */
export function ImageAvatarAvatar24(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="avatar24"
                width={32}
                height={32}
                src={PATH_AVATAR_AVATAR24}
                srcSet={`${PATH_AVATAR_AVATAR24} 1x`}
                {...props}
                />;
}

/** avatar/avatar25 */
export function ImageAvatarAvatar25(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="avatar25"
                width={32}
                height={32}
                src={PATH_AVATAR_AVATAR25}
                srcSet={`${PATH_AVATAR_AVATAR25} 1x`}
                {...props}
                />;
}

/** avatar/avatar26 */
export function ImageAvatarAvatar26(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="avatar26"
                width={32}
                height={32}
                src={PATH_AVATAR_AVATAR26}
                srcSet={`${PATH_AVATAR_AVATAR26} 1x`}
                {...props}
                />;
}

/** avatar/avatar27 */
export function ImageAvatarAvatar27(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="avatar27"
                width={32}
                height={32}
                src={PATH_AVATAR_AVATAR27}
                srcSet={`${PATH_AVATAR_AVATAR27} 1x`}
                {...props}
                />;
}

/** avatar/avatar28 */
export function ImageAvatarAvatar28(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="avatar28"
                width={32}
                height={32}
                src={PATH_AVATAR_AVATAR28}
                srcSet={`${PATH_AVATAR_AVATAR28} 1x`}
                {...props}
                />;
}

/** avatar/avatar29 */
export function ImageAvatarAvatar29(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="avatar29"
                width={32}
                height={32}
                src={PATH_AVATAR_AVATAR29}
                srcSet={`${PATH_AVATAR_AVATAR29} 1x`}
                {...props}
                />;
}

/** avatar/avatar3 */
export function ImageAvatarAvatar3(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="avatar3"
                width={32}
                height={32}
                src={PATH_AVATAR_AVATAR3}
                srcSet={`${PATH_AVATAR_AVATAR3} 1x`}
                {...props}
                />;
}

/** avatar/avatar4 */
export function ImageAvatarAvatar4(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="avatar4"
                width={32}
                height={32}
                src={PATH_AVATAR_AVATAR4}
                srcSet={`${PATH_AVATAR_AVATAR4} 1x`}
                {...props}
                />;
}

/** avatar/avatar5 */
export function ImageAvatarAvatar5(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="avatar5"
                width={32}
                height={32}
                src={PATH_AVATAR_AVATAR5}
                srcSet={`${PATH_AVATAR_AVATAR5} 1x`}
                {...props}
                />;
}

/** avatar/avatar6 */
export function ImageAvatarAvatar6(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="avatar6"
                width={32}
                height={32}
                src={PATH_AVATAR_AVATAR6}
                srcSet={`${PATH_AVATAR_AVATAR6} 1x`}
                {...props}
                />;
}

/** avatar/avatar7 */
export function ImageAvatarAvatar7(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="avatar7"
                width={32}
                height={32}
                src={PATH_AVATAR_AVATAR7}
                srcSet={`${PATH_AVATAR_AVATAR7} 1x`}
                {...props}
                />;
}

/** avatar/avatar8 */
export function ImageAvatarAvatar8(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="avatar8"
                width={32}
                height={32}
                src={PATH_AVATAR_AVATAR8}
                srcSet={`${PATH_AVATAR_AVATAR8} 1x`}
                {...props}
                />;
}

/** avatar/avatar9 */
export function ImageAvatarAvatar9(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="avatar9"
                width={32}
                height={32}
                src={PATH_AVATAR_AVATAR9}
                srcSet={`${PATH_AVATAR_AVATAR9} 1x`}
                {...props}
                />;
}

/** brand/kibelo */
export function ImageBrandKibelo(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="kibelo"
                width={349}
                height={386}
                src={PATH_BRAND_KIBELO}
                srcSet={`${PATH_BRAND_KIBELO} 1x`}
                {...props}
                />;
}

/** credit_card/amex */
export function ImageCreditCardAmex(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="amex"
                width={750}
                height={471}
                src={PATH_CREDIT_CARD_AMEX}
                srcSet={`${PATH_CREDIT_CARD_AMEX} 1x`}
                {...props}
                />;
}

/** credit_card/jcb */
export function ImageCreditCardJcb(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="jcb"
                width={750}
                height={471}
                src={PATH_CREDIT_CARD_JCB}
                srcSet={`${PATH_CREDIT_CARD_JCB} 1x`}
                {...props}
                />;
}

/** credit_card/mastercard */
export function ImageCreditCardMastercard(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="mastercard"
                width={750}
                height={471}
                src={PATH_CREDIT_CARD_MASTERCARD}
                srcSet={`${PATH_CREDIT_CARD_MASTERCARD} 1x`}
                {...props}
                />;
}

/** credit_card/visa */
export function ImageCreditCardVisa(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="visa"
                width={750}
                height={471}
                src={PATH_CREDIT_CARD_VISA}
                srcSet={`${PATH_CREDIT_CARD_VISA} 1x`}
                {...props}
                />;
}

/** emptystate/en/blog_feed */
export function ImageEmptystateEnBlogFeed(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="blog_feed"
                width={1520}
                height={500}
                src={PATH_EMPTYSTATE_EN_BLOG_FEED_2X}
                srcSet={`${PATH_EMPTYSTATE_EN_BLOG_FEED_2X} 2x`}
                {...props}
                />;
}

/** emptystate/en/wiki_feed */
export function ImageEmptystateEnWikiFeed(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="wiki_feed"
                width={1520}
                height={534}
                src={PATH_EMPTYSTATE_EN_WIKI_FEED_2X}
                srcSet={`${PATH_EMPTYSTATE_EN_WIKI_FEED_2X} 2x`}
                {...props}
                />;
}

/** emptystate/en/wiki_tree */
export function ImageEmptystateEnWikiTree(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="wiki_tree"
                width={720}
                height={480}
                src={PATH_EMPTYSTATE_EN_WIKI_TREE_2X}
                srcSet={`${PATH_EMPTYSTATE_EN_WIKI_TREE_2X} 2x`}
                {...props}
                />;
}

/** emptystate/ja/blog_feed */
export function ImageEmptystateJaBlogFeed(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="blog_feed"
                width={1520}
                height={500}
                src={PATH_EMPTYSTATE_JA_BLOG_FEED_2X}
                srcSet={`${PATH_EMPTYSTATE_JA_BLOG_FEED_2X} 2x`}
                {...props}
                />;
}

/** emptystate/ja/wiki_feed */
export function ImageEmptystateJaWikiFeed(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="wiki_feed"
                width={1520}
                height={534}
                src={PATH_EMPTYSTATE_JA_WIKI_FEED_2X}
                srcSet={`${PATH_EMPTYSTATE_JA_WIKI_FEED_2X} 2x`}
                {...props}
                />;
}

/** emptystate/ja/wiki_tree */
export function ImageEmptystateJaWikiTree(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="wiki_tree"
                width={720}
                height={480}
                src={PATH_EMPTYSTATE_JA_WIKI_TREE_2X}
                srcSet={`${PATH_EMPTYSTATE_JA_WIKI_TREE_2X} 2x`}
                {...props}
                />;
}

/** feed/empty_box_bg */
export function ImageFeedEmptyBoxBg(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="empty_box_bg"
                width={204}
                height={129}
                src={PATH_FEED_EMPTY_BOX_BG}
                srcSet={`${PATH_FEED_EMPTY_BOX_BG} 1x,${PATH_FEED_EMPTY_BOX_BG_2X} 2x`}
                {...props}
                />;
}

/** icon-192 */
export function ImageIcon192(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="icon-192"
                width={192}
                height={192}
                src={PATH_ICON_192}
                srcSet={`${PATH_ICON_192} 1x`}
                {...props}
                />;
}

/** importer/docbase_logo */
export function ImageImporterDocbaseLogo(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="docbase_logo"
                width={20}
                height={20}
                src={PATH_IMPORTER_DOCBASE_LOGO}
                srcSet={`${PATH_IMPORTER_DOCBASE_LOGO} 1x,${PATH_IMPORTER_DOCBASE_LOGO_2X} 2x`}
                {...props}
                />;
}

/** importer/esa_logo */
export function ImageImporterEsaLogo(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="esa_logo"
                width={20}
                height={20}
                src={PATH_IMPORTER_ESA_LOGO}
                srcSet={`${PATH_IMPORTER_ESA_LOGO} 1x,${PATH_IMPORTER_ESA_LOGO_2X} 2x`}
                {...props}
                />;
}

/** importer/qiita_team_logo */
export function ImageImporterQiitaTeamLogo(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="qiita_team_logo"
                width={20}
                height={20}
                src={PATH_IMPORTER_QIITA_TEAM_LOGO}
                srcSet={`${PATH_IMPORTER_QIITA_TEAM_LOGO} 1x,${PATH_IMPORTER_QIITA_TEAM_LOGO_2X} 2x`}
                {...props}
                />;
}

/** kibela_logo */
export function ImageKibelaLogo(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="kibela_logo"
                width={75}
                height={20}
                src={PATH_KIBELA_LOGO}
                srcSet={`${PATH_KIBELA_LOGO} 1x`}
                {...props}
                />;
}

/** kibela_logo_staging */
export function ImageKibelaLogoStaging(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="kibela_logo_staging"
                width={75}
                height={20}
                src={PATH_KIBELA_LOGO_STAGING}
                srcSet={`${PATH_KIBELA_LOGO_STAGING} 1x`}
                {...props}
                />;
}

/** landing/icon-patterns */
export function ImageLandingIconPatterns(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="icon-patterns"
                width={946}
                height={342}
                src={PATH_LANDING_ICON_PATTERNS}
                srcSet={`${PATH_LANDING_ICON_PATTERNS} 1x`}
                {...props}
                />;
}

/** landing/pattern-bg */
export function ImageLandingPatternBg(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="pattern-bg"
                width={3360}
                height={944}
                src={PATH_LANDING_PATTERN_BG}
                srcSet={`${PATH_LANDING_PATTERN_BG} 1x`}
                {...props}
                />;
}

/** landing/pmark */
export function ImageLandingPmark(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="pmark"
                width={140}
                height={140}
                src={PATH_LANDING_PMARK}
                srcSet={`${PATH_LANDING_PMARK} 1x`}
                {...props}
                />;
}

/** on_boarding/en/1 */
export function ImageOnBoardingEn1(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="1"
                width={680}
                height={360}
                src={PATH_ON_BOARDING_EN_1_2X}
                srcSet={`${PATH_ON_BOARDING_EN_1_2X} 2x`}
                {...props}
                />;
}

/** on_boarding/en/2 */
export function ImageOnBoardingEn2(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="2"
                width={680}
                height={360}
                src={PATH_ON_BOARDING_EN_2_2X}
                srcSet={`${PATH_ON_BOARDING_EN_2_2X} 2x`}
                {...props}
                />;
}

/** on_boarding/en/3 */
export function ImageOnBoardingEn3(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="3"
                width={680}
                height={360}
                src={PATH_ON_BOARDING_EN_3_2X}
                srcSet={`${PATH_ON_BOARDING_EN_3_2X} 2x`}
                {...props}
                />;
}

/** on_boarding/en/4 */
export function ImageOnBoardingEn4(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="4"
                width={680}
                height={360}
                src={PATH_ON_BOARDING_EN_4_2X}
                srcSet={`${PATH_ON_BOARDING_EN_4_2X} 2x`}
                {...props}
                />;
}

/** on_boarding/ja/1 */
export function ImageOnBoardingJa1(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="1"
                width={680}
                height={360}
                src={PATH_ON_BOARDING_JA_1_2X}
                srcSet={`${PATH_ON_BOARDING_JA_1_2X} 2x`}
                {...props}
                />;
}

/** on_boarding/ja/2 */
export function ImageOnBoardingJa2(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="2"
                width={680}
                height={360}
                src={PATH_ON_BOARDING_JA_2_2X}
                srcSet={`${PATH_ON_BOARDING_JA_2_2X} 2x`}
                {...props}
                />;
}

/** on_boarding/ja/3 */
export function ImageOnBoardingJa3(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="3"
                width={680}
                height={360}
                src={PATH_ON_BOARDING_JA_3_2X}
                srcSet={`${PATH_ON_BOARDING_JA_3_2X} 2x`}
                {...props}
                />;
}

/** on_boarding/ja/4 */
export function ImageOnBoardingJa4(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="4"
                width={680}
                height={360}
                src={PATH_ON_BOARDING_JA_4_2X}
                srcSet={`${PATH_ON_BOARDING_JA_4_2X} 2x`}
                {...props}
                />;
}

/** shortcut_icon */
export function ImageShortcutIcon(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="shortcut_icon"
                width={200}
                height={200}
                src={PATH_SHORTCUT_ICON}
                srcSet={`${PATH_SHORTCUT_ICON} 1x`}
                {...props}
                />;
}

/** sorry */
export function ImageSorry(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="sorry"
                width={390}
                height={261}
                src={PATH_SORRY}
                srcSet={`${PATH_SORRY} 1x`}
                {...props}
                />;
}

/** square_seal */
export function ImageSquareSeal(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="square_seal"
                width={400}
                height={400}
                src={PATH_SQUARE_SEAL}
                srcSet={`${PATH_SQUARE_SEAL} 1x`}
                {...props}
                />;
}

/** terms/pmark-en */
export function ImageTermsPmarkEn(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="pmark-en"
                width={100}
                height={100}
                src={PATH_TERMS_PMARK_EN}
                srcSet={`${PATH_TERMS_PMARK_EN} 1x`}
                {...props}
                />;
}

/** terms/pmark-ja */
export function ImageTermsPmarkJa(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="pmark-ja"
                width={100}
                height={100}
                src={PATH_TERMS_PMARK_JA}
                srcSet={`${PATH_TERMS_PMARK_JA} 1x`}
                {...props}
                />;
}

/** toast/error */
export function ImageToastError(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="error"
                width={20}
                height={20}
                src={PATH_TOAST_ERROR}
                srcSet={`${PATH_TOAST_ERROR} 1x`}
                {...props}
                />;
}

/** toast/success */
export function ImageToastSuccess(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="success"
                width={20}
                height={20}
                src={PATH_TOAST_SUCCESS}
                srcSet={`${PATH_TOAST_SUCCESS} 1x`}
                {...props}
                />;
}

/** webhook/microsoft_teams_icon */
export function ImageWebhookMicrosoftTeamsIcon(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="microsoft_teams_icon"
                width={64}
                height={64}
                src={PATH_WEBHOOK_MICROSOFT_TEAMS_ICON}
                srcSet={`${PATH_WEBHOOK_MICROSOFT_TEAMS_ICON} 1x`}
                {...props}
                />;
}

/** webhook/slack_icon */
export function ImageWebhookSlackIcon(props?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    return <img alt="slack_icon"
                width={20}
                height={20}
                src={PATH_WEBHOOK_SLACK_ICON_1X}
                srcSet={`${PATH_WEBHOOK_SLACK_ICON_1X} 1x,${PATH_WEBHOOK_SLACK_ICON_2X} 2x`}
                {...props}
                />;
}
